import { useLayoutEffect, useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Button, Input, Checkbox } from 'appkit-react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';

// eslint-disable-next-line import/no-unresolved
import logo from 'assets/images/pwc-new-logo.png';
// eslint-disable-next-line import/no-unresolved
import groupImage from 'assets/images/pwc_cubes.png';
// eslint-disable-next-line import/no-unresolved
import { capitalizeFunc } from 'utils';
import '../styles/index.scss';

const baseLink = process.env.REACT_APP_BASE_LINK;
const Login = () => {
    const isChecked = localStorage.getItem('rememberMe');
    const prevEmail = localStorage.getItem('email');
    const [size, setSize] = useState([0, 0]);
    const [email, setEmail] = useState(prevEmail || '');
    const [rememberMe, setRememberMe] = useState(isChecked === 'true');
    const [rememberUser, setRememberUser] = useState(prevEmail || '');
    const [userName, setUserName] = useState('');

    const history = useHistory();

    const handleSelfRegisterRedirect = () => {
        history.push('/registration-intake');
    };

    /* function called when LOGIN button is clicked */
 const onLogin = async val => {
    // ✅ Pass email to backend so it can add login_hint
    const signinUrl = val
        ? `${baseLink}api/signin`
        : `${baseLink}api/signin?email=${encodeURIComponent(email)}`;

    const { data } = await axios({
        url: signinUrl,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });

    if (val) {
        if (data.url) {
            window.location.href = data.url;
        }
    } else {
        if (rememberMe) {
            localStorage.setItem('rememberMe', rememberMe);
            localStorage.setItem('email', email);
        } else {
            localStorage.removeItem('email');
            localStorage.setItem('rememberMe', rememberMe);
        }
        if (data.url) {
            // ✅ Just use the URL from backend — it already has login_hint
            window.location.href = data.url;
        }
    }
};

    /* side effect when screen size is changed */
    useLayoutEffect(() => {
        function updateSize() {
            setSize([window.innerWidth, window.innerHeight]);
        }
        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);

    useEffect(() => {
        if (rememberUser && rememberUser !== '') {
            setUserName(capitalizeFunc(rememberUser.split('.')[0]));
        }
    }, [rememberUser]);
    return (
        <div className="true-comply-login-container" style={{ height: '95vh' }}>
            <Row>
                <Col md={1}>
                    <div style={{ height: '70px' }}>
                        <img src={logo} className="true-comply-login-page-logo" alt="logo Icon" />
                    </div>
                </Col>
                <Col md={4} style={{ marginLeft: '1rem' }}>
                    <div
                        className="a-h6 true-comply-login-product-name"
                    >
                        Report Inspector
                    </div>
                    {userName && userName !== '' && (
                        <div
                            className="true-comply-login-welcome-text"
                        >
                            It&apos;s nice to have you back,
                            {' '}
                            <span style={{ fontWeight: 'bold' }}>{`${userName}.`}</span>
                        </div>
                    )}
                    <div
                        className="true-comply-login-page-login-form"
                    >
                        <div className="form-label a-h6" style={{ marginBottom: '0.5rem' }}>USERNAME</div>
                        <Input
                            type="text"
                            name="email"
                            value={email}
                            placeholder="abc@xyz.com"
                            onChange={e => { setEmail(e); }}
                        />
                        <div className="true-comply-login-page-login-form-footer">
                            <div className="true-comply-login-page-login-form-check-box">
                                <Checkbox
                                    checked={rememberMe}
                                    onChange={e => { setRememberMe(e.target.checked); }}
                                    style={{ backgroundColor: 'white' }}
                                />
                                <span style={{ paddingLeft: '0.75rem', fontSize: '1rem', color: '#000000' }}>Remember me</span>
                            </div>
                            <div className="true-comply-login-page-login-form-button">
                                <Button size="xl" kind="primary" onClick={() => onLogin(false)}>
                                    Login
                                </Button>
                            </div>
                        </div>
                    </div>
                    <hr
                        style={{
                            borderWidth: '1px', borderColor: '#2d2d2d', marginTop: '1.5rem', width: '23.827rem',
                        }}
                    />
                    <div className="true-comply-login-page-idam-button">
                        <Button
                            size="xl"
                            kind="transparent"
                            onClick={handleSelfRegisterRedirect}
                        >
                            Intrested? Fill Intake Form
                        </Button>
                    </div>
                    {/* <div className="true-comply-login-page-idam-button">
                        <Button size="xl" kind="transparent" onClick={() => onLogin(true)}>
                            PWC IDAM
                        </Button>
                    </div> */}
                </Col>
                <Col md={6}>
                    <div className="true-comply-login-page-group_image">
                        <img src={groupImage} className="login-page-image" alt="Group_image" />
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default Login;
